export default __webpack_public_path__ + "static/media/reply.16ab42e8.svg";